import * as React from 'react';
import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import { StatusIcon, EStatusIconType } from '.';

// Styles
const s = require('./StatusIconWithLabel.css');

// Props
interface IStatusIconWithLabelProps {
    className?: string;
    iconClassName?: string;
    type?: EStatusIconType;
    label?: string;
    labelOnRight?: boolean;
}

// Component
@observer
export class StatusIconWithLabel extends React.Component<IStatusIconWithLabelProps, {}> {
    static get defaultProps(): IStatusIconWithLabelProps {
        return {
            className: null,
            iconClassName: null,
            type: EStatusIconType.Success,
            label: null,
            labelOnRight: false
        };
    }

    public render() {
        return (
            <p className={classNames(s.status, this.props.className)}>
                {this.props.label && this.props.labelOnRight === false && this.renderLabel()}
                <StatusIcon type={this.props.type} className={classNames(s.icon, this.props.iconClassName)} />
                {this.props.label && this.props.labelOnRight === true && this.renderLabel()}
            </p>
        );
    }

    public renderLabel() {
        return (
            <em>{this.props.label}</em>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/indicator/StatusIconWIthLabel.tsx